export default function routeTransitionsConfig($transitionsProvider) {
	const routeLookups = {};

	const recordPageView = (transition) => {
		try {
			const targetDefinition = transition.to();
			const targetRequested = transition.targetState();
			const targetUrl = transition.router.stateService.href(targetDefinition.name, targetRequested.params, { absolute: true });
			const $logger = transition.injector().get("$logger");
			const via = targetRequested.params().via;

			if(routeLookups[targetDefinition.name] === undefined) {
				routeLookups[targetDefinition.name] = getTargetRoute(targetRequested.$state());
			}

			const targetRoute = routeLookups[targetDefinition.name];

			$logger.view(targetRoute, targetUrl, { via });
		}
		catch(error) {
			// do nothing on exception
		}
	};

	function getTargetRoute(targetState) {
		if(targetState.parent) {
			return `${getTargetRoute(targetState.parent)}${targetState.self.url}`;
		}
		return targetState.self.url;
	}

	const setTitle = (transition) => {
		let title = transition.to().title;

		if(title) {
			if(title instanceof Function) {
				title = title.call(transition.to(), transition.params());
			}
			window.document.title = title;
		}
	};
	const transitionAuthCriteria = {
		to: state => {
			return state.data && (state.data.permissionKeys || state.data.actionScope);
		}
	};

	$transitionsProvider.onSuccess({}, trans => {
		recordPageView(trans);
		setTitle(trans);
	});

	$transitionsProvider.onEnter(transitionAuthCriteria, transitionAuthHandler, {
		priority: 10
	});

	$transitionsProvider.onBefore({ to: () => true }, transitionClassHandler, {
		priority: 10
	});

	$transitionsProvider.onError({}, (transition) => {
		const error = transition.error();

		if(error.type === 6) {
			transition.router.stateService.go("unauthenticated.failed", { system: true, errorMsg: error.detail }, { location: false });
		}

	}, { priority: 10 });

	function transitionAuthHandler(transition) {
		const { data } = transition.targetState().state();
		const appState = transition.injector().get("appState");

		if(data?.actionScope) {
			const securityService = transition.injector().get("securityService");
			if(securityService.isActionScopeAllowed(data.actionScope)) {
				return true;
			}
			else if(!data?.permissionKeys) {
				return false;
			}
		}

		if(data?.permissionKeys) {
			const keys = data.permissionKeys.split(">");

			let index = 0;
			let permissionBlob = appState.permissions[keys[index++]];
			while(index < keys.length) {
				if(permissionBlob.IsDisabled) {
					break;
				}
				permissionBlob = permissionBlob[keys[index++]];
			}

			if(permissionBlob.IsDisabled) {
				const $state = transition.router.stateService;
				return $state.target("authenticated.dashboard", undefined, {
					location: true
				});
			}

			return true;
		}

		return true;
	}

	function transitionClassHandler(transition) {
		const data = transition.targetState().state().data;
		const uiState = transition.injector().get("uiState");
		if(data && data.bodyClassName) {
			uiState.stateClass = data.bodyClassName;
		} else {
			uiState.stateClass = null;
		}

		uiState.sidebar.open = false;
	}
}
